<template lang="pug">
.action
  .controls(:class="{ selected, error }")
    button.toggle(@click.stop.prevent="openModal", v-html="actionText")
    SelectorLength(v-if="parameter === 'cable' && $mq.desktop")

  TransitionFade
    SelectionModal(
      @close="closeModal",
      v-if="open",
      :toggle="toggle",
      :products="products",
      :parameter="parameter"
    )
</template>

<script>
import SelectorLength from "./SelectorLength";
import SelectionModal from "./SelectionModal";
import TransitionFade from "@/transitions/Fade";
export default {
  name: "SelectionAction",
  props: ["actionText", "open", "selected", "products", "error", "parameter"],
  components: {
    SelectorLength,
    SelectionModal,
    TransitionFade,
  },
  data() {
    return {
      toggle: null,
    };
  },
  methods: {
    openModal() {
      this.$emit("open");
    },
    closeModal() {
      this.$emit("close");
    },
  },
  mounted() {
    this.toggle = this.$el.querySelector(".toggle");
  },
};
</script>

<style lang="scss" scoped>
.action {
  display: flex;
  flex-direction: column;
  flex: 1 1 0%;
}

.controls {
  padding: clamp(0.25rem, 2vw, .25rem) 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: relative;
  gap: 1rem 2rem;
  flex: 1 1 100%;

  &.selected button {
    background: $buttonSecondaryBackground;
    color: $buttonSecondaryColor;
    &:hover {
      background: $buttonSecondaryBackgroundHover;
      color: $buttonSecondaryColorHover;
    }
  }

  &.error button {
    background: $buttonHighlightBackground;
    color: $buttonHighlightColor;
    &:hover {
      background: $buttonHighlightBackgroundHover;
      color: $buttonHighlightColorHover;
    }
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    appearance: none;
    border: none;
    border-radius: 0;
    background: $buttonPrimaryBackground;
    color: $buttonPrimaryColor;
    transition: 0.25s ease;
    padding: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    cursor: pointer;
    font-size: 0.6875rem;
    min-height: 30px;
    min-width: 30px;

    @include mq(lg) {
      min-height: 40px;
      min-width: 40px;
    }

    &:hover {
      background: $buttonPrimaryBackgroundHover;
      color: $buttonPrimaryColorHover;
    }

    &::v-deep span {
      @include mqdn(lg) {
        @include hideVisually;
      }
    }
  }
}
</style>